module.exports = __webpack_public_path__ + "static/logoCSlanding-5cb2420010f06be2d422db397ebe27e1.png";